export const STEPS = {
  PHOTOS: 'photos',
  INFO: 'info',
  VALUES: 'values',
  WARRANTY: 'warranty',
  CONFIRMATION: 'confirmation',
}
